type SlotUidMapping = {
  [key: string]: string;
};

export class SlotUid {
  constructor(private readonly map: SlotUidMapping = {}) {}

  private generateUidForSlot(slotName: string): void {
    this.map[slotName] = crypto.randomUUID();
  }

  getUid(slotName: string): string {
    if (this.map[slotName] !== undefined) {
      return this.map[slotName];
    }

    this.generateUidForSlot(slotName);
    return this.getUid(slotName);
  }
}
